import { createStyles, makeStyles } from '@material-ui/styles';
import { AnswerProps } from './index';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: (props: Omit<AnswerProps, 'response' | 'onClick'>) => {
        if (props.backgroundColor === 'orange') return 'rgb(215, 137, 21, 0.7)';
        if (props.backgroundColor === 'violet') return 'rgb(220, 2, 255, 0.7)';
        if (props.backgroundColor === 'blue') return 'rgb(0, 0, 255, 0.7)';
      },
      width: '70%',
      height: 'auto',
      minHeight: '90px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '10px',
      color: 'white',
      cursor: 'pointer',
      transition: '0.3s',
      boxSizing: 'border-box',
      padding: '20px',
      '&:hover': {
        boxShadow: palette.shadows.boxShadow,
        backgroundColor: (props: Omit<AnswerProps, 'response' | 'onClick'>) => {
          if (props.backgroundColor === 'orange') return 'rgb(215, 137, 21, 1)';
          if (props.backgroundColor === 'violet') return 'rgb(220, 2, 255, 1)';
          if (props.backgroundColor === 'blue') return 'rgb(0, 0, 255, 1)';
        }
      },
      '@media (max-width: 724px)': {
        width: '100%',
        height: '180px'
      }
    },
    text: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: '29px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
